var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 151,
    viewBox: "0 0 283 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105 104C133.719 104 157 80.7188 157 52C157 23.2812 133.719 0 105 0C76.2812 0 53 23.2812 53 52C53 80.7188 76.2812 104 105 104Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M166 141C194.719 141 218 117.719 218 89C218 60.2812 194.719 37 166 37C137.281 37 114 60.2812 114 89C114 117.719 137.281 141 166 141Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117 151C145.719 151 169 127.719 169 99C169 70.2812 145.719 47 117 47C88.2812 47 65 70.2812 65 99C65 127.719 88.2812 151 117 151Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M157 111C185.719 111 209 87.7188 209 59C209 30.2812 185.719 7 157 7C128.281 7 105 30.2812 105 59C105 87.7188 128.281 111 157 111Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M137 124C165.719 124 189 100.719 189 72C189 43.2812 165.719 20 137 20C108.281 20 85 43.2812 85 72C85 100.719 108.281 124 137 124Z",
    fill: "#FFC844"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M134.796 45.2989C135.611 43.3385 138.389 43.3385 139.204 45.2988L144.904 59.004C145.248 59.8305 146.025 60.3951 146.917 60.4667L161.713 61.6528C163.83 61.8225 164.688 64.4637 163.075 65.8449L151.802 75.5014C151.123 76.0837 150.826 76.9973 151.033 77.868L154.478 92.3062C154.97 94.3715 152.723 96.0038 150.912 94.8971L138.244 87.16C137.48 86.6934 136.52 86.6934 135.756 87.16L123.088 94.8971C121.277 96.0038 119.03 94.3715 119.522 92.3063L122.967 77.868C123.174 76.9973 122.877 76.0837 122.198 75.5014L110.925 65.8449C109.312 64.4637 110.17 61.8225 112.287 61.6528L127.083 60.4667C127.975 60.3951 128.752 59.8305 129.096 59.004L134.796 45.2989Z",
    fill: "#24284E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M230.326 132.94C243.548 133.865 255.017 123.895 255.941 110.673C256.866 97.4501 246.897 85.9816 233.674 85.057C220.451 84.1324 208.983 94.1018 208.058 107.324C207.134 120.547 217.103 132.015 230.326 132.94Z",
    fill: "#FFC844"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M231.845 96.6333C232.283 95.757 233.562 95.8464 233.874 96.7752L236.058 103.269C236.189 103.66 236.529 103.945 236.937 104.007L243.711 105.03C244.68 105.176 244.99 106.419 244.204 107.004L238.702 111.087C238.371 111.333 238.205 111.744 238.272 112.151L239.393 118.91C239.553 119.877 238.466 120.556 237.668 119.988L232.085 116.018C231.748 115.778 231.306 115.747 230.939 115.938L224.858 119.092C223.988 119.543 223.006 118.719 223.299 117.784L225.35 111.248C225.473 110.854 225.366 110.423 225.072 110.133L220.193 105.324C219.495 104.637 219.975 103.448 220.955 103.438L227.805 103.368C228.218 103.364 228.594 103.129 228.779 102.76L231.845 96.6333Z",
    fill: "#24284E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5342 52.9461C58.6549 52.0985 67.7936 41.5857 66.946 29.465C66.0985 17.3443 55.5856 8.20569 43.465 9.05325C31.3443 9.90081 22.2056 20.4136 23.0532 32.5343C23.9008 44.655 34.4136 53.7936 46.5342 52.9461Z",
    fill: "#FFC844"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2815 19.7945C43.5678 18.9431 44.7398 18.8611 45.1418 19.6644L47.9521 25.2804C48.1216 25.6191 48.4662 25.8344 48.8449 25.8383L55.1245 25.9023C56.0227 25.9114 56.4628 27.0008 55.823 27.6313L51.3503 32.0395C51.0806 32.3053 50.9823 32.6997 51.0956 33.061L52.9753 39.053C53.2442 39.9101 52.3441 40.6653 51.5467 40.2517L45.9722 37.3601C45.636 37.1857 45.2306 37.2141 44.922 37.4335L39.8041 41.0728C39.0721 41.5934 38.0757 40.9707 38.2226 40.0846L39.2501 33.8893C39.312 33.5157 39.1598 33.1389 38.8557 32.9132L33.813 29.1704C33.0917 28.635 33.376 27.495 34.2642 27.361L40.4737 26.4237C40.8482 26.3672 41.1595 26.1059 41.2802 25.747L43.2815 19.7945Z",
    fill: "#24284E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 110,
    r: 3,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 78,
    r: 3,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 10,
    r: 3,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 245,
    cy: 143,
    r: 2,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 141.5,
    r: 1.5,
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M227 22.5L250 13",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39 112.5L17 122",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M253 76L276 78",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints);
export default __webpack_public_path__ + "static/media/points.6d3ba7d8bf17fefaa9fda733870e4d3b.svg";
export { ForwardRef as ReactComponent };